/**
 * reportApiError — capture centralisée des échecs SERVEUR (5xx) + erreurs réseau au
 * niveau de la couche HTTP partagée (apiCallWithToken). UN point couvre TOUS les
 * appels de service, quel que soit le catch du composant appelant (§5/§9 DRY).
 *
 * Volontairement en .js SANS import statique de @sentry/react : ce module est importé
 * par apiCallWithToken.js, lui-même couvert par le gate jest racine (tests/unit/),
 * dont le transform babel ne gère ni la syntaxe TS ni le build ESM de @sentry/react.
 * On charge donc Sentry en lazy-require dans un try/catch (no-op en test ou si le SDK
 * est indisponible). Ne capture QUE les 5xx + erreurs réseau (les 4xx = métier attendu).
 * Ne throw JAMAIS (§107) ; l'event repasse par beforeSend=scrubbedEvent (scrub).
 */
export function reportApiError(err, ctx = {}) {
  try {
    const status = err && err.response && err.response.status;
    const isNetwork = !(err && err.response); // pas de réponse = timeout / DNS / offline / CORS
    if (!isNetwork && (typeof status !== 'number' || status < 500)) return;
    // eslint-disable-next-line global-require
    const Sentry = require('@sentry/react');
    const path = (ctx.url || '').split('?')[0];
    Sentry.withScope((scope) => {
      scope.setTag('source', 'api');
      if (ctx.method) scope.setTag('http_method', String(ctx.method).toUpperCase());
      scope.setTag('http_status', typeof status === 'number' ? String(status) : 'network');
      if (path) scope.setTag('api_path', path);
      const e = err instanceof Error ? err : new Error('API ' + (status || 'network') + ' ' + path);
      Sentry.captureException(e);
    });
  } catch (_) {
    /* §107 — une capture Sentry ne doit jamais casser le flux applicatif. */
  }
}

export default reportApiError;
